import React from 'react'
import { useConfig } from 'msp-integrations'
import PriceTag from './PriceTag'
import * as T from './CommerceBox.types'

const CommerceBoxTile = ({
  product,
  CTAButton,
  innerRef,
  isPDP = false,
  onAddToCart,
  noPadding,
  showLowestPrice
}: T.CommerceBoxTileProps) => {
  const {
    price,
    c_basePrice,
    c_priceDiscounted,
    c_minSetPrice,
    currency,
    inventory,
    c_inventory,
    c_lastMonthPrice,
    c_lastMonthPriceCallback
  } = product
  const { orderable } = inventory || c_inventory || {}
  const {
    theme: { font }
  } = useConfig()

  return (
    <div
      className={`flex h-full flex-col justify-between space-y-3 lg:space-y-8 ${
        noPadding ? '' : 'p-3'
      }`}
      ref={innerRef}
    >
      <div className={'text-16 xl:text-18'}>
        <div className={`${font.regular} text-black`}>{product.name}</div>
        <div className={`${font.regular} text-mediumGray truncate`}>
          {product.shortDescription}
        </div>
      </div>
      <PriceTag
        className=''
        discountPrice={c_priceDiscounted}
        c_basePrice={c_basePrice}
        price={c_minSetPrice || price}
        showTaxesInfo
        currency={currency}
        isPDP={isPDP}
        showLowestPrice={showLowestPrice}
        lastMonthPrice={c_lastMonthPrice}
        lastMonthPriceCallback={c_lastMonthPriceCallback}
      />
      <div
        className={!orderable ? 'cursor-not-allowed' : 'cursor-pointer'}
        onClick={() => {
          if (onAddToCart && orderable) {
            onAddToCart(1)
          }
        }}
      >
        {CTAButton}
      </div>
    </div>
  )
}

export default CommerceBoxTile
